/**
 * @module Helpers
 */

export default {
  /**
 * helper function
 * @function
 * @param {string} accept - string
 * @returns {string / obj } either string or obj
 */

  /**
   *
   * @param {string} - returns string first letter uppercase
   */
  firstLetterUppercase: string => string[0].toUpperCase() + string.slice(1),

  /**
   * Accept array and returns unique array
   * @param {array} - returns array
   */
  getUniqueArrayItems: arrArg => arrArg.filter((elem, pos, arr) => arr.indexOf(elem) === pos),
  /**
   *
   * @param {*} obj : Accept object
   * @param {*} textKey : key
   * @param {*} textValue : value
   * @param {*} inner : if inner array value
   * @returns text and key obj list from given set of args
   */
  getSelectableValue(obj, textKey, textValue, inner = false) {
    const arr = [];
    // eslint-disable-next-line
    for (const item of obj) {
      if (inner) {
        arr.push({
          text: item[inner][textKey],
          value: item[inner][textValue],
        });
      } else {
        arr.push({
          text: item[textKey],
          value: item[textValue],
        });
      }
    }
    return arr;
  },
  /**
   *
   * @param {*} data : Accept object
   * @returns : blank key value of given obj
   */
  setObjValueEmpty(data) {
    // eslint-disable-next-line
    for (const key in data) {
      data[key] = '';
    }
    return data;
  },

  /**
   *
   * @param {*} arr array
   * @param {*} fieldKey string
   * Returns [keyfied, keyfield]
   */
  getFieldValueInArray(arr, fieldKey) {
    if (arr.length < 1) {
      return [];
    }
    const arrData = [];
    arr.map(item => arrData.push(item[fieldKey]));
    return arrData;
  },
  /**
   *
   *  Clone array
   */
  copyArray(src) {
    let target = [];
    for (let prop in src) {
      if (src.hasOwnProperty(prop)) {
        target[prop] = src[prop];
      }
    }
    return target;
  },
  // Convert to base 64
  toBase64(file){
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  },

   buildQueryStringFromObj(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  },

  isValidDateYYYY_MM_DD(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if(!dateString.match(regEx)) return false;  // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0,10) === dateString;
  },

  validate(form, rules){
    let status = true;
    let message = 'success';
    for(let key in rules){
      if(form[key] == ''){
        status = false;
        message = 'Please fill in ' + key.replace(/_/g, ' ');
        break;
      }
    }
    return {
      status,
      message,
    }
  },

  getFullSerialNumber(form) {
    return form.hasOrderNumber ? form.order_number +'-'+ form.sku_number +'-'+ form.serial_number : form.sku_number +'-'+ form.serial_number;
  },

  getDetailFromGmapAutoComplete(address_components, key, targetValue = '') {
    let returnValue = '';
    let searchdata = address_components.find(item => {
      if (_.indexOf(item.types, key) > -1) {
        return item;
      }
    })
    if (searchdata != undefined) {
      returnValue = targetValue ? searchdata[targetValue] : searchdata.long_name;
    }
    return returnValue;
  },

  getLatLngFromGoogleAutoComplete(addressData) {
    let lat;
    let lng;
    // get my location
    if (typeof addressData.geometry.location.lat === 'function') {
      lat = addressData.geometry.location.lat();
      lng = addressData.geometry.location.lng();
    } else {
      lat = addressData.geometry.location.lat;
      lng = addressData.geometry.location.lng;
    }
    return {
      lat,
      lng
    };
  },
  

};
